/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2021 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers. The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */
import { contentModeCookieName } from "@insite/client-framework/Common/ContentMode";
import { getCookie } from "@insite/client-framework/Common/Cookies";
import addDays from "@insite/client-framework/Common/Utilities/addDays";

export const isItCheckoutPage = (pageType: string) => {
    const isCheckoutPage = ["CheckoutReviewAndSubmitPage", "CheckoutShippingPage"].indexOf(pageType) > -1;
    const isCmsEditing = getCookie(contentModeCookieName) === "Editing";

    return isCheckoutPage && !isCmsEditing;
};

export const isStillDisabledDueEligibilityLimit = (order: any, daysOfRmaEligibility: any) => {
    if (!order || !order.properties || !order.properties.invoiceDate) {
        return false;
    }

    const invoiceDate = new Date(order.properties.invoiceDate);
    const currentDate = new Date();
    const lastDateOfDisabling = addDays(invoiceDate, daysOfRmaEligibility || 0);

    return lastDateOfDisabling < currentDate;
};